(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-slideshow"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initBannerSlideshow($) {
    $('.slider').each(function() {
      var $this = $(this);

      if ($this.data('mmBannerInitialized')) {
        return;
      }

      $this.data('mmBannerInitialized', true);

      var $group = $this.find('.slide_group');
      var $slides = $this.find('.slide');
      var bulletArray = [];
      var currentIndex = 0;
      var isMoving = false;
      var timeout;

      function move(newIndex) {
        var animateLeft, slideLeft;

        advance();

        if (isMoving || currentIndex === newIndex) {
          return;
        }

        isMoving = true;
        bulletArray[currentIndex].removeClass('active');
        bulletArray[newIndex].addClass('active');

        if (newIndex > currentIndex) {
          slideLeft = '100%';
          animateLeft = '-100%';
        } else {
          slideLeft = '-100%';
          animateLeft = '100%';
        }

        $slides.eq(newIndex).css({
          display: 'block',
          left: slideLeft
        });
        var moveCompleted = false;
        function completeMove() {
          if (moveCompleted) {
            return;
          }

          moveCompleted = true;
          $slides.eq(currentIndex).css({
            display: 'none'
          });
          $slides.eq(newIndex).css({
            left: 0
          });
          $group.css({
            left: 0,
            transform: 'translateX(0)',
            transition: ''
          });
          currentIndex = newIndex;
          isMoving = false;
        }

        $group
          .one('transitionend.mmBannerSlideshow', completeMove)
          .css({
            transform: 'translateX(' + animateLeft + ')',
            transition: 'transform 400ms ease'
          });

        setTimeout(completeMove, 450);
      }

      function advance() {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
          if (currentIndex < ($slides.length - 1)) {
            move(currentIndex + 1);
          } else {
            move(0);
          }
        }, 6000);
      }

      $this.find('.next_btn').on('click', function() {
        if (currentIndex < ($slides.length - 1)) {
          move(currentIndex + 1);
        } else {
          move(0);
        }
      });

      $this.find('.previous_btn').on('click', function() {
        if (currentIndex !== 0) {
          move(currentIndex - 1);
        } else {
          move($slides.length - 1);
        }
      });

      $.each($slides, function(index) {
        var $button = $('<a class="slide_btn">&bull;</a>');

        if (index === currentIndex) {
          $button.addClass('active');
        }
        $button.on('click', function() {
          move(index);
        }).appendTo($this.find('.slide_buttons'));
        bulletArray.push($button);
      });

      advance();
    });
  }

  function waitForJQuery() {
    if (window.jQuery) {
      initBannerSlideshow(window.jQuery);
    } else {
      setTimeout(waitForJQuery, 50);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForJQuery);
  } else {
    waitForJQuery();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-slideshow102023"] && !Shopify.designMode) return;
  try {
    
$('.slider2').each(function() {
  var $this = $(this);
  var $group = $this.find('.slide_group2');
  var $slides = $this.find('.slide2');
  var bulletArray = [];
  var currentIndex = 0;
  var timeout;
  
  function move(newIndex) {
    var animateLeft, slideLeft;
    
    advance();
    
    if ($group.is(':animated') || currentIndex === newIndex) {
      return;
    }
    
    bulletArray[currentIndex].removeClass('active');
    bulletArray[newIndex].addClass('active');
    
    if (newIndex > currentIndex) {
      slideLeft = '100%';
      animateLeft = '-100%';
    } else {
      slideLeft = '-100%';
      animateLeft = '100%';
    }
    
    $slides.eq(newIndex).css({
      display: 'block',
      left: slideLeft
    });
    $group.animate({
      left: animateLeft
    }, function() {
      $slides.eq(currentIndex).css({
        display: 'none'
      });
      $slides.eq(newIndex).css({
        left: 0
      });
      $group.css({
        left: 0
      });
      currentIndex = newIndex;
    });
  }
  
  function advance() {
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      if (currentIndex < ($slides.length - 1)) {
        move(currentIndex + 1);
      } else {
        move(0);
      }
    }, 6000);
  }
  
  $('.next_btn2').on('click', function() {
    if (currentIndex < ($slides.length - 1)) {
      move(currentIndex + 1);
    } else {
      move(0);
    }
  });
  
  $('.previous_btn2').on('click', function() {
    if (currentIndex !== 0) {
      move(currentIndex - 1);
    } else {
      move($slides.length - 1);
    }
  });
  
  $.each($slides, function(index) {
    var $button = $('<a class="slide_btn2">&bull;</a>');
    
    if (index === currentIndex) {
      $button.addClass('active');
    }
    $button.on('click', function() {
      move(index);
    }).appendTo('.slide_buttons2');
    bulletArray.push($button);
  });
  
  advance();
});

  } catch(e) { console.error(e); }
})();
})();
